import React, {useEffect} from "react";
import { Button} from "antd";

// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { MenuCategorias } from "./components/MenuCategorias/menu-categorias.view";
import { SelectCategoria } from "./components/Selects/select-categoria.view";

import "./categorias.style.scss";
import { useCategoriasJurados } from "../../../hooks/useCategoriasJurados";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { Footer } from "../../../components/Landing/Footer";

export const Categorias = () => {
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    areas,
    categoriasSelected,
    handleCheckBoxChange,
    refCheckBox,
    handleSubmit,
    handleConocimientoChange,
    handleAreaPrincipalChange,
    prevScreen,
    areaPrincipal,
    conocimiento,
    counter,
    loading,
  } = useCategoriasJurados();

  useEffect(() => {
    getConvocatoriaPersistente();
  }, []);

  return (
    <>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Áreas de conocimiento" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <div className="row">
          <div className="row mt-4 g-1 pe-0">
            <div className="col-1 ms-1 me-0 d-flex justify-content-center align-content-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion background-seleccionar-postulacion-verde">
              2
            </div>
            <span className="col ps-0 ms-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Categorías
            </span>
          </div>

          <div className="col-12 mt-4">
            <SelectCategoria
              areas={areas}
              handleConocimientoChange={handleConocimientoChange}
              handleAreaPrincipalChange={handleAreaPrincipalChange}
              areaPrincipal={areaPrincipal}
              conocimiento={conocimiento}
            />
          </div>
          <div className="col-12 mt-4">
            <MenuCategorias
              counter={counter}
              areas={areas}
              categoriasSelected={categoriasSelected}
              handleCheckBoxChange={handleCheckBoxChange}
              refCheckBox={refCheckBox}
              areaprincipal={areaPrincipal}
            />
          </div>

          <div
            className="col bg-white"
            style={{
              justifyContent: "center",
              position: "sticky",
              bottom: 0,
              paddingBottom: "0%",
            }}
          >
            <div className="justify-content-end">
              <div className="col justify-content-flex-end">
                <Button className="button-blanco-radius" style={{ marginRight: '10px'}} onClick={prevScreen}>
                  Atrás
                </Button>
                <Button
                  disabled={loading}
                  className="button-azul-radius"
                  onClick={handleSubmit}
                >
                  Continuar
                  {loading && (
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                    />
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
